import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ManagedDepartmentFragment } from '@api/fragments'
import { IManagedDepartment } from '@api/types'

interface IPayload {
  data: {
    employee: {
      departmentAdmins: IManagedDepartment[]
    }
  }
}

export default function managedDepartments(id: string): Promise<IManagedDepartment[]> {
  return client.gql
    .query({ query, variables: { id } })
    .then(({ data: { employee } }: IPayload) => employee.departmentAdmins)
}

const query = gql`
  query EmployeeManagedDepartments($id: ID!) {
    employee: node(id: $id) {
      ... on Employee {
        departmentAdmins {
          department {
            ...ManagedDepartmentFragment
          }
        }
      }
    }
  }
  ${ManagedDepartmentFragment}
`
